<template>
    <div
        v-on-clickaway="away"
        :class="[
            'select',
            ...containerClass,
            {
                active: isActive,
                disabled: disabled,
            },
        ]"
        @click="isActive = ! isActive;"
    >
        <div
            class="select-choice"
            :class="{ 'select-placeholder': selectedOption.isPlaceholder || false }"
        >
            <span v-if="selectPrefix">{{ selectPrefix }}</span> {{ selectedOption.label }}
        </div>
        <ul class="select-content">
            <li
                v-for="option in options"
                :key="option.value"
            >
                <a
                    :class="[{selected: selectedOption.value === option.value}]"
                    @click.prevent="handleSelectClick(option)"
                >
                    {{ option.label }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { find } from 'lodash';

export default {
    mixins: [clickaway],

    props: {
        options: {
            type: Array,
            required: true,
        },
        selectPrefix: {
            type: String,
            default: '',
        },
        initialValue: {
            type: [String, Boolean],
            default: false,
        },
        containerClass: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        selectedOption: {
            value: null,
            label: '',
        },
        isActive: false,
    }),

    watch: {
        /**
         * Selects initial value after updating available options.
         *
         * @param  {object[]} options Available options.
         */
        options(options) {
            if (!! options.length && !! this.initialValue && ! this.selectedOption.value) {
                this.selectedOption = find(options, ['value', this.initialValue]);
            }
        },
    },

    /**
     * Mounted hook
     */
    mounted() {
        if (0 < this.placeholder.length && ! this.initialValue) {
            this.selectedOption = {
                label: this.placeholder,
                value: null,
                isPlaceholder: true,
            };
            this.$emit('change', null);
        } else if (this.initialValue && !! this.options.length) {
            this.selectedOption = find(this.options, ['value', this.initialValue]);
        } else if (this.options.length) {
            this.selectedOption = this.options[0];
            this.$emit('change', this.selectedOption.value);
        }
    },

    methods: {
        /**
         * Handles close dropdown
         */
        away() {
            this.isActive = false;
        },

        /**
         * [handleSelectClick description]
         *
         * @param   {object}  option   Option configuration object.
         */
        handleSelectClick(option) {
            if (! this.disabled) {
                this.selectedOption = option;
                this.$emit('change', this.selectedOption.value);
            }
        },
    },
};
</script>
